define((require) => {
    "use strict";

    var ImprovedView                = require("editor/zbone/ImprovedView"),
        Effect                      = require("shared/ui/experience/action/effects/EffectModel"),
        ImageToggleEffectModel      = require("shared/ui/experience/action/effects/ImageToggleEffectModel"),
        OpacityEffectModel          = require("shared/ui/experience/action/effects/OpacityEffectModel"),
        EffectLibraryView           = require("ui/experience/action/EffectLibraryView"),
        template                    = require("ui/experience/action/EffectsView.tpl");

    /**
     * @cfg {AbstractWidgetModel}
     */
    return ImprovedView.extend({

        _effects: null,

        _hoverEffectLibrary: null,

        _attentionEffectLibrary: null,

        template: template,

        initialize: function() {
            this._effects = this.model.get("effects");
            this.listenTo(this._effects, "add remove reset", this._updateToModel);
            this.listenTo(this.options.viewModel.get("experience"), "change:emailModeEnabled", this.onShow);
        },

        regions: {
            hoverRegion: ".hover-region",
            attentionRegion: ".attention-region"
        },

        ui: {
            hoverEffectEnabled: ".hover-effect-enabled",
            attentionEffectEnabled: ".attention-effect-enabled",
            attentionEffectWrapper: ".attention-effect-wrapper",
            hoverRegion: ".hover-region",
            attentionRegion: ".attention-region"
        },

        events: {
            "change .hover-effect-enabled": function() {
                this._hoverEffectLibrary.enabled(this.ui.hoverEffectEnabled.is(":checked"));
            },

            "change .attention-effect-enabled": function() {
                this._attentionEffectLibrary.enabled(this.ui.attentionEffectEnabled.is(":checked"));
            }
        },

        onRender: function() {
            this._hoverEffectLibrary = new EffectLibraryView({
                model: this.model, viewModel: this.viewScope.viewModel, effects: this._effects, triggerType: Effect.TRIGGER_TYPE_HOVER
            });
            this._attentionEffectLibrary = new EffectLibraryView({
                model: this.model, viewModel: this.viewScope.viewModel, effects: this._effects, triggerType: Effect.TRIGGER_TYPE_ATTENTION
            });
        },

        _toggleAttentionEffectLibrary: function() {
            const isEmailModeEnabled = this.options.viewModel.get("experience").get("emailModeEnabled");
            if (isEmailModeEnabled) {
                // Here we remove ALL "loop" effects for email mode
                this.ui.attentionEffectEnabled.prop("checked", false);
                this.ui.attentionEffectEnabled.change();

                // Here we check for incompatible "hover" effects.
                // Only opacity and image swapping allowed. Otherwise switch of hover effect
                const currentHoverEffects = this._hoverEffectLibrary.model.get("effects");
                const hasImageToggleEffect = currentHoverEffects.findWhere({type: ImageToggleEffectModel.TYPE});
                const hasOpacityEffect = currentHoverEffects.findWhere({type: OpacityEffectModel.TYPE});
                if (!hasOpacityEffect && !hasImageToggleEffect) {
                    this.ui.hoverEffectEnabled.prop("checked", false);
                    this.ui.hoverEffectEnabled.change();
                }
            }
            this.ui.attentionEffectEnabled.prop("disabled", isEmailModeEnabled);
            this.ui.attentionEffectWrapper.toggleClass("disabled", isEmailModeEnabled);
        },

        _updateToModel: function() {
            this.model.trigger("change:effects", this.model);

            var hasHoverEffect = this._effects.hasTriggerType(Effect.TRIGGER_TYPE_HOVER),
                hasAttentionEffect = this._effects.hasTriggerType(Effect.TRIGGER_TYPE_ATTENTION);

            this.ui.hoverEffectEnabled.prop("checked", hasHoverEffect);
            this.ui.hoverRegion.toggle(hasHoverEffect);

            this.ui.attentionEffectEnabled.prop("checked", hasAttentionEffect);
            this.ui.attentionRegion.toggle(hasAttentionEffect);
        },

        onShow: function() {
            this.hoverRegion.show(this._hoverEffectLibrary);
            this.attentionRegion.show(this._attentionEffectLibrary);

            this._updateToModel();
            this._toggleAttentionEffectLibrary();
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/EffectsView.js